import Exception from "core/exceptions/Exception";
import DefaultExceptionTypes from "core/exceptions/DefaultExceptionTypes";

/**
 * Standardized result wrapper for repository operations
 * Provides consistent success/error handling across all repositories
 */
export interface RepositoryResult<T> {
  success: boolean;
  data?: T;
  exception?: Exception<unknown, DefaultExceptionTypes>;
}

/**
 * Factory functions for creating RepositoryResult instances
 */
export class RepositoryResultFactory {
  /**
   * Creates a successful result
   */
  static success<T>(data: T): RepositoryResult<T> {
    return {
      success: true,
      data,
    };
  }

  /**
   * Creates an error result with exception
   */
  static error<T>(
    exception: Exception<unknown, DefaultExceptionTypes>
  ): RepositoryResult<T> {
    return {
      success: false,
      exception,
    };
  }

  /**
   * Creates an error result without exception (fallback)
   */
  static errorWithoutException<T>(
    message: string = "Operation failed"
  ): RepositoryResult<T> {
    return {
      success: false,
      exception: {
        type: DefaultExceptionTypes.UNKNOWN_ERROR,
        message,
      },
    };
  }
}
